import React, { useContext } from 'react';

import styled, { css } from 'styled-components';

import { DarkModeContext } from '../context/DarkModeContext';
import { COLORS, SIZE } from '../common/constants';

const Button = ({ text, link, onClick }) => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	return (
		<BasicButton isDarkModeOn={isDarkModeOn}>
			<Logo></Logo>
			<ButtonText
				onClick={onClick}
				href={link}
				target='_blank'
				rel='noopener noreferrer'
			>
				{text}
			</ButtonText>
		</BasicButton>
	);
};

export default Button;

// 🎨 Styled Components
const BasicButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	position: relative;
	top: 4px;
	margin-bottom: 1em;
	cursor: pointer;
`;

const Logo = styled.div`
	width: 1em;
	height: 1em;
	border-radius: 50%;
	background-color: ${COLORS.somGreen};
	position: relative;
`;

const ButtonText = styled.a`
	position: relative;
	top: 7px;
	left: -5px;
	font-size: calc(15.6px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
	font-family: 'Montserrat', sans-serif;
	color: ${COLORS.grey};
	font-weight: 500;
	text-align: left;
	/* ${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.mainAqua};
		`} */
	&:hover {
		opacity: 0.6;
	}
	&::selection{
		background-color:${COLORS.somOrange};
		color:${COLORS.white}
	}
`;

// ${(props) =>
// 	props.isDarkModeOn &&
// 	css`
// 		background: ${COLORS.lightAqua};
// 		color: ${COLORS.white};
// 	`}

// &:hover {
// 	transition: all 0.3s ease 0s;
// 	background: rgb(19, 46, 193);
// 	background: linear-gradient(
// 		0deg,
// 		rgba(19, 46, 193, 1) 0%,
// 		rgba(31, 57, 202, 1) 100%
// 	);
// }
// &:hover {
// 	${(props) =>
// 		props.isDarkModeOn &&
// 		css`
// 			background: ${COLORS.mainAqua};
// 			color: ${COLORS.white};
// 		`}
// }
